import { type Product } from '../methods/useProductFetchClient';
import { graphql, fetchQuery, type Environment } from 'react-relay';
import { createAtlAttributionHeader } from '../../../utils';
import { type getTenantRegionQuery } from './__generated__/getTenantRegionQuery.graphql';

export const getTenantRegion = async (
	product: Product,
	cloudIds: string[],
	relayEnvironment?: Environment,
): Promise<string> => {
	if (!relayEnvironment) {
		return '';
	}

	try {
		const observable = fetchQuery<getTenantRegionQuery>(
			relayEnvironment,
			graphql`
				query getTenantRegionQuery($cloudIds: [ID!], $product: String!) {
					tenantContexts(cloudIds: $cloudIds) {
						activationIdByProduct(product: $product) {
							targetRegion
						}
					}
				}
			`,
			{
				cloudIds,
				product,
			},
			{
				networkCacheConfig: {
					metadata: {
						headers: {
							'atl-attribution': createAtlAttributionHeader(),
						},
					},
				},
			},
		);

		return new Promise<string>((resolve) => {
			observable.subscribe({
				next: (data) => {
					resolve(data?.tenantContexts?.[0]?.activationIdByProduct?.targetRegion || '');
				},
				error: () => {
					resolve('');
				},
			});
		});
	} catch {
		return '';
	}
};
